module.exports = __webpack_public_path__ + "static/media/029-smartphone-3.7851c4c3.svg";